import { Col, Row, Badge, Card, Typography } from "antd";
import PropTypes from "prop-types";
import React from "react";
import Tag from "components/cards/tag";
// import TransactionsLevel from "./transactionsLevel";
// import Warning from "./warning";

export default function HistoryChatCard({
  number,
  unreadMessagesCount,
  name,
  message,
  active,
  warning,
  isTyping,
  transactionsLevel,
  onClick,
  tag,
}) {
  return (
    <Card
      onClick={onClick}
      hoverable
      style={{ backgroundColor: active ? "lightblue" : "" }}
    >
      {/* {transactionsLevel && <TransactionsLevel level={transactionsLevel} />} */}
      {/* {warning && <Warning text={warning} />} */}
      <Row gutter={24} justify="space-between">
        <Col span={1}>
          <Typography.Text type="warning" style={{ textAlign: "center" }}>
            {number}
          </Typography.Text>
        </Col>
        {tag && <Tag tag={tag} />}
        <Col span={19}>
          <Typography.Text type="primary" style={{ textAlign: "center" }}>
            {name}
          </Typography.Text>
        </Col>
        <Col span={2}>
          <Badge count={unreadMessagesCount} />
        </Col>
      </Row>
      <p>
        <Typography.Text type="secondary">{message}</Typography.Text>
      </p>
    </Card>
  );
}

HistoryChatCard.propTypes = {
  number: PropTypes.number.isRequired,
  unreadMessagesCount: PropTypes.number,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  transactionsLevel: PropTypes.string,
  message: PropTypes.string,
};

HistoryChatCard.defaultProps = {
  active: false,
  unreadMessagesCount: 0,
  transactionsLevel: null,
  message: null,
};
